import './FormScenario.css';
import { useForm } from 'react-hook-form';
import TitleBlock from '../TitleBlock/TitleBlock';
import binarySearchString from '../../../utils/binarySearchString';
import { useTreeStateContext } from '/src/features/editor/contexts/TreeContext';
import { BlockScenarioDefault } from '../../../data/constant/blocks/BlockScenarioDefault';
import editorAction from '../../../actions/editorAction';
function FormScenario({id}) {

    const { blocks } = useTreeStateContext();
    const { updateBlocksName } = editorAction();
    const indexBlock = binarySearchString(blocks, id, 'object_id');
    const block = blocks[indexBlock] ?  blocks[indexBlock] : BlockScenarioDefault
    const name = block.name;
    
    const { register, setError, clearErrors, handleSubmit, control, formState: { errors }, formState, getValues, setValue } = useForm({
        mode: "onBlur",
        defaultValues: {
            title: name,
        },
    });

    const updateBlocksJumpLinkToScenario = (value) => {
        const blocksToUpdate = blocks.filter(block => block.type.name == 'magic' && block.name == `Jump to ${name}`).map(block => {return {...block, name : `Jump to ${value}`}});
        if(blocksToUpdate.length == 0) return;
        updateBlocksName(blocksToUpdate)
    }
 
    return (
        <>
            <TitleBlock title="Scenario" titleInput="Scenario name" name={name} id={id} callback={updateBlocksJumpLinkToScenario}/>
        </>
    )
}

export default FormScenario;